// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Personalizador del menú: pestañas, selector de modo y editor de favoritos.
 *
 * Solo clases nuevas (\`mcz-\`); la lista de visibilidad sigue usando \`mvc-\`.
 */

.mcz-tabs {
  display: flex;
  gap: 4px;
  padding: 0 0 10px;
  margin-bottom: 14px;
  border-bottom: 1px solid var(--border);
}

.mcz-tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: var(--text-muted);
  font-family: inherit;
  font-size: 0.84rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s, border-color 0.15s;
}

.mcz-tab:hover {
  color: var(--text-primary);
  background: var(--bg-toolbar);
}

.mcz-tab.is-active {
  color: var(--accent-l);
  border-color: rgb(var(--accent-rgb) / 0.5);
  background: rgb(var(--accent-rgb) / 0.12);
}

.mcz-tab-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: rgb(var(--accent-rgb) / 0.2);
  font-size: 0.7rem;
  font-weight: 600;
  line-height: 1;
}

/* ── Selector de modo ─────────────────────────────────────────────────────── */

.mcz-mode {
  margin-bottom: 14px;
}

.mcz-mode-heading {
  margin: 0 0 8px;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-primary);
}

.mcz-mode-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 10px;
}

.mcz-mode-card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 14px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--bg-card);
  color: var(--text-secondary);
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s, background-color 0.15s;
}

.mcz-mode-card:hover {
  border-color: rgb(var(--accent-rgb) / 0.5);
}

.mcz-mode-card.is-active {
  border-color: var(--accent);
  background: rgb(var(--accent-rgb) / 0.08);
  box-shadow: inset 0 0 0 1px rgb(var(--accent-rgb) / 0.35);
}

.mcz-mode-title {
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--text-primary);
}

.mcz-mode-desc {
  font-size: 0.76rem;
  line-height: 1.4;
  color: var(--text-muted);
}

.mcz-mode-badge {
  align-self: flex-start;
  margin-top: 4px;
  padding: 1px 7px;
  border-radius: 999px;
  background: rgb(var(--accent-rgb) / 0.16);
  color: var(--accent-l);
  font-size: 0.64rem;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.mcz-hint {
  margin: 4px 0 10px;
  font-size: 0.78rem;
  line-height: 1.45;
  color: var(--text-muted);
}

/* ── Favoritos ────────────────────────────────────────────────────────────── */

.mcz-favs {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.mcz-scope {
  display: inline-flex;
  align-self: flex-start;
  padding: 3px;
  border: 1px solid var(--border);
  border-radius: 9px;
  background: var(--bg-toolbar);
  gap: 3px;
  margin-bottom: 8px;
}

.mcz-scope-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: var(--text-muted);
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s;
}

.mcz-scope-btn:hover {
  color: var(--text-primary);
}

.mcz-scope-btn.is-active {
  background: var(--bg-card);
  color: var(--accent-l);
  font-weight: 600;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.15);
}

.mcz-favs-hint {
  margin: 0 0 8px;
  font-size: 0.78rem;
  line-height: 1.45;
  color: var(--text-muted);
}

.mcz-selected {
  margin: 4px 0 12px;
  padding: 10px 12px;
  border: 1px solid rgb(var(--accent-rgb) / 0.35);
  border-radius: 10px;
  background: rgb(var(--accent-rgb) / 0.06);
}

.mcz-selected-title {
  margin-bottom: 6px;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: var(--text-muted);
}

.mcz-selected-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  border-top: 1px solid var(--border);
}

.mcz-selected-row:first-of-type {
  border-top: none;
}

.mcz-selected-star {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  color: var(--accent-l);
}

.mcz-selected-label {
  flex: 1 1;
  font-size: 0.82rem;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mcz-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--bg-card);
  color: var(--text-muted);
  cursor: pointer;
  transition: color 0.15s, border-color 0.15s;
}

.mcz-icon-btn svg {
  width: 13px;
  height: 13px;
  stroke-width: 2;
}

.mcz-icon-btn:hover:not(:disabled) {
  color: var(--accent-l);
  border-color: rgb(var(--accent-rgb) / 0.5);
}

.mcz-icon-btn:disabled {
  opacity: 0.35;
  cursor: default;
}

.mcz-icon-btn.is-danger:hover:not(:disabled) {
  color: #dc2626;
  border-color: rgba(220, 38, 38, 0.5);
}

.mcz-fav-group {
  margin-bottom: 10px;
}

.mcz-fav-group-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.mcz-fav-group-head h4 {
  margin: 0;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-primary);
}

.mcz-fav-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.mcz-fav-items {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: 5px;
}

.mcz-fav-item {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 6px 9px;
  border: 1px solid var(--border);
  border-radius: 7px;
  background: var(--bg-card);
  color: var(--text-secondary);
  font-family: inherit;
  font-size: 0.78rem;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s, background-color 0.15s;
}

.mcz-fav-item:hover:not(:disabled) {
  border-color: rgb(var(--accent-rgb) / 0.5);
  color: var(--text-primary);
}

.mcz-fav-item.is-favorite {
  border-color: var(--accent);
  background: rgb(var(--accent-rgb) / 0.1);
  color: var(--text-primary);
}

.mcz-fav-item.is-locked {
  opacity: 0.45;
  cursor: not-allowed;
}

.mcz-fav-star {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  stroke-width: 1.6;
  color: var(--text-muted);
}

.mcz-fav-item.is-favorite .mcz-fav-star {
  color: var(--accent-l);
}

.mcz-fav-item span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mcz-fav-lock {
  width: 12px;
  height: 12px;
  margin-left: auto;
  flex-shrink: 0;
  color: var(--text-muted);
}
`, "",{"version":3,"sources":["webpack://./src/components/MenuCustomizer.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mEAAmE;AACrE;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gFAAgF;;AAEhF;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,wEAAwE;AAC1E;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,yCAAyC;EACzC,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,6BAA6B;EAC7B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,wBAAwB;EACxB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mEAAmE;AACrE;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,wBAAwB;AAC1B","sourcesContent":["/**\r\n * Personalizador del menú: pestañas, selector de modo y editor de favoritos.\r\n *\r\n * Solo clases nuevas (`mcz-`); la lista de visibilidad sigue usando `mvc-`.\r\n */\r\n\r\n.mcz-tabs {\r\n  display: flex;\r\n  gap: 4px;\r\n  padding: 0 0 10px;\r\n  margin-bottom: 14px;\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.mcz-tab {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 14px;\r\n  border: 1px solid transparent;\r\n  border-radius: 8px;\r\n  background: transparent;\r\n  color: var(--text-muted);\r\n  font-family: inherit;\r\n  font-size: 0.84rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background-color 0.15s, color 0.15s, border-color 0.15s;\r\n}\r\n\r\n.mcz-tab:hover {\r\n  color: var(--text-primary);\r\n  background: var(--bg-toolbar);\r\n}\r\n\r\n.mcz-tab.is-active {\r\n  color: var(--accent-l);\r\n  border-color: rgb(var(--accent-rgb) / 0.5);\r\n  background: rgb(var(--accent-rgb) / 0.12);\r\n}\r\n\r\n.mcz-tab-count {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 18px;\r\n  height: 18px;\r\n  padding: 0 5px;\r\n  border-radius: 9px;\r\n  background: rgb(var(--accent-rgb) / 0.2);\r\n  font-size: 0.7rem;\r\n  font-weight: 600;\r\n  line-height: 1;\r\n}\r\n\r\n/* ── Selector de modo ─────────────────────────────────────────────────────── */\r\n\r\n.mcz-mode {\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.mcz-mode-heading {\r\n  margin: 0 0 8px;\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.mcz-mode-options {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\r\n  gap: 10px;\r\n}\r\n\r\n.mcz-mode-card {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  padding: 12px 14px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  background: var(--bg-card);\r\n  color: var(--text-secondary);\r\n  font-family: inherit;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: border-color 0.15s, box-shadow 0.15s, background-color 0.15s;\r\n}\r\n\r\n.mcz-mode-card:hover {\r\n  border-color: rgb(var(--accent-rgb) / 0.5);\r\n}\r\n\r\n.mcz-mode-card.is-active {\r\n  border-color: var(--accent);\r\n  background: rgb(var(--accent-rgb) / 0.08);\r\n  box-shadow: inset 0 0 0 1px rgb(var(--accent-rgb) / 0.35);\r\n}\r\n\r\n.mcz-mode-title {\r\n  font-size: 0.88rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.mcz-mode-desc {\r\n  font-size: 0.76rem;\r\n  line-height: 1.4;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.mcz-mode-badge {\r\n  align-self: flex-start;\r\n  margin-top: 4px;\r\n  padding: 1px 7px;\r\n  border-radius: 999px;\r\n  background: rgb(var(--accent-rgb) / 0.16);\r\n  color: var(--accent-l);\r\n  font-size: 0.64rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.4px;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.mcz-hint {\r\n  margin: 4px 0 10px;\r\n  font-size: 0.78rem;\r\n  line-height: 1.45;\r\n  color: var(--text-muted);\r\n}\r\n\r\n/* ── Favoritos ────────────────────────────────────────────────────────────── */\r\n\r\n.mcz-favs {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.mcz-scope {\r\n  display: inline-flex;\r\n  align-self: flex-start;\r\n  padding: 3px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 9px;\r\n  background: var(--bg-toolbar);\r\n  gap: 3px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.mcz-scope-btn {\r\n  padding: 6px 12px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  background: transparent;\r\n  color: var(--text-muted);\r\n  font-family: inherit;\r\n  font-size: 0.78rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background-color 0.15s, color 0.15s;\r\n}\r\n\r\n.mcz-scope-btn:hover {\r\n  color: var(--text-primary);\r\n}\r\n\r\n.mcz-scope-btn.is-active {\r\n  background: var(--bg-card);\r\n  color: var(--accent-l);\r\n  font-weight: 600;\r\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.15);\r\n}\r\n\r\n.mcz-favs-hint {\r\n  margin: 0 0 8px;\r\n  font-size: 0.78rem;\r\n  line-height: 1.45;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.mcz-selected {\r\n  margin: 4px 0 12px;\r\n  padding: 10px 12px;\r\n  border: 1px solid rgb(var(--accent-rgb) / 0.35);\r\n  border-radius: 10px;\r\n  background: rgb(var(--accent-rgb) / 0.06);\r\n}\r\n\r\n.mcz-selected-title {\r\n  margin-bottom: 6px;\r\n  font-size: 0.68rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.8px;\r\n  text-transform: uppercase;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.mcz-selected-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 4px 0;\r\n  border-top: 1px solid var(--border);\r\n}\r\n\r\n.mcz-selected-row:first-of-type {\r\n  border-top: none;\r\n}\r\n\r\n.mcz-selected-star {\r\n  width: 14px;\r\n  height: 14px;\r\n  flex-shrink: 0;\r\n  color: var(--accent-l);\r\n}\r\n\r\n.mcz-selected-label {\r\n  flex: 1;\r\n  font-size: 0.82rem;\r\n  color: var(--text-primary);\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.mcz-icon-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 24px;\r\n  height: 24px;\r\n  padding: 0;\r\n  border: 1px solid var(--border);\r\n  border-radius: 6px;\r\n  background: var(--bg-card);\r\n  color: var(--text-muted);\r\n  cursor: pointer;\r\n  transition: color 0.15s, border-color 0.15s;\r\n}\r\n\r\n.mcz-icon-btn svg {\r\n  width: 13px;\r\n  height: 13px;\r\n  stroke-width: 2;\r\n}\r\n\r\n.mcz-icon-btn:hover:not(:disabled) {\r\n  color: var(--accent-l);\r\n  border-color: rgb(var(--accent-rgb) / 0.5);\r\n}\r\n\r\n.mcz-icon-btn:disabled {\r\n  opacity: 0.35;\r\n  cursor: default;\r\n}\r\n\r\n.mcz-icon-btn.is-danger:hover:not(:disabled) {\r\n  color: #dc2626;\r\n  border-color: rgba(220, 38, 38, 0.5);\r\n}\r\n\r\n.mcz-fav-group {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.mcz-fav-group-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.mcz-fav-group-head h4 {\r\n  margin: 0;\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.mcz-fav-dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.mcz-fav-items {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));\r\n  gap: 5px;\r\n}\r\n\r\n.mcz-fav-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  padding: 6px 9px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 7px;\r\n  background: var(--bg-card);\r\n  color: var(--text-secondary);\r\n  font-family: inherit;\r\n  font-size: 0.78rem;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: border-color 0.15s, color 0.15s, background-color 0.15s;\r\n}\r\n\r\n.mcz-fav-item:hover:not(:disabled) {\r\n  border-color: rgb(var(--accent-rgb) / 0.5);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.mcz-fav-item.is-favorite {\r\n  border-color: var(--accent);\r\n  background: rgb(var(--accent-rgb) / 0.1);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.mcz-fav-item.is-locked {\r\n  opacity: 0.45;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.mcz-fav-star {\r\n  width: 14px;\r\n  height: 14px;\r\n  flex-shrink: 0;\r\n  stroke-width: 1.6;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.mcz-fav-item.is-favorite .mcz-fav-star {\r\n  color: var(--accent-l);\r\n}\r\n\r\n.mcz-fav-item span {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.mcz-fav-lock {\r\n  width: 12px;\r\n  height: 12px;\r\n  margin-left: auto;\r\n  flex-shrink: 0;\r\n  color: var(--text-muted);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
